import axiosIns from '@/libs/axios'
import moment from 'moment'

const ROOT_URL = '/Admin/data/account_activities'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      ddate: moment().format('YYYY-MM-DD'),
      amount: null,
      notes: null,
      update_notes: null,
      is_receipt: '0',
      receipt_no: null,
      donor_name: null,
      donor_phone: null,
      donor_address: null,
      main_group: null,
      donation_group: null,
      donation_type: null,
      bank_account: null,
      currency: null,
      safe: null,
      account_type: null,
      id_donation_groups: null,
      id_account_types: null,
      id_safes: null,
      id_bank_accounts: null,
      id_currencies: '1',
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    donorSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      id_account_types: null,
      id_types: null,
      id_donation_groups: [],
      id_bank_accounts: [],
      id_safes: [],
      sdate: null,
      edate: null,
      min_amount: null,
      max_amount: null,
      is_transferred: true,
      receipt_status: 'all',
    },
    dataModal: {
      status: false,
      dataItem: null,
    },
    transferModal: {
      status: false,
      dataItem: null,
    },
    transferDataItem: {
      id: null,
      ddate: moment().format('YYYY-MM-DD'),
      amount: null,
      former_amount: null,
      notes: null,
      id_donation_groups: null,
      id_bank_accounts: null,
      id_donation_types: null,
      id_account_types: null,
      id_currencies: null,
    },
    countersData: [],
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    donorSaveStatus(state) {
      return state.donorSave
    },
    filterParams(state) {
      return state.filterParams
    },
    dataModal(state) {
      return state.dataModal
    },
    transferModal(state) {
      return state.transferModal
    },
    transferDataItem(state) {
      return state.transferDataItem
    },
    countersData(state) {
      return state.countersData
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DONOR_SAVE(state, data) {
      state.donorSave = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_COUNTERS(state, data) {
      state.countersData = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        ddate: moment().format('YYYY-MM-DD'),
        amount: null,
        notes: null,
        update_notes: null,
        is_receipt: '0',
        receipt_no: null,
        donor_name: null,
        donor_phone: null,
        donor_address: null,
        main_group: null,
        donation_group: null,
        donation_type: null,
        bank_account: null,
        currency: null,
        safe: null,
        account_type: null,
        id_donation_groups: null,
        id_account_types: null,
        id_safes: null,
        id_bank_accounts: null,
        id_currencies: '1',
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getCustomList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/getList`, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getBankTransfer({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/bankTransfer`, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getCounters({ commit }) {
      axiosIns
        .post(`${ROOT_URL}/getCounters`)
        .then(response => {
          commit('SET_COUNTERS', response.data)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'account_activities.id': id,
        },
        array: false,
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    transferData({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/transferData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    donorSaveData({ commit }, params) {
      return axiosIns
        .post(`${ROOT_URL}/donorSaveData`, params)
        .then(response => {
          commit('SET_DONOR_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
